<!-- Loader component start-->
<app-loader></app-loader>
<!-- Loader component end-->
<router-outlet></router-outlet>
<!-- Scroll Top component start -->
<app-scroll-top></app-scroll-top>
<!-- Scroll Top component end -->